import { Train, Car } from "lucide-react";
import { eur } from "@/lib/api";

const Option = ({ icon: Icon, label, data, recommended, detailed, testid, cheapest, fastest }) => {
  const off = data && data.available === false;
  return (
    <div data-testid={testid} className={`rounded-xl border p-3 ${recommended ? "border-emerald-600 bg-emerald-50/60" : "border-gray-200"} ${off ? "opacity-50" : ""}`}>
      <div className="flex flex-wrap items-center justify-between gap-x-2">
        <span className="flex items-center gap-1.5 text-sm font-semibold text-gray-800"><Icon className="w-4 h-4" />{label}</span>
        {recommended && !off ? <span className="text-[10px] font-mono uppercase tracking-wider text-emerald-700">Conseillé</span> : null}
      </div>
      {off ? (
        <p className="mt-1 text-xs text-gray-500">Non pertinent</p>
      ) : (
        <p className="mt-1 text-xs text-gray-600">{data?.duration} · <span className="font-semibold text-gray-900">{eur(data?.price)}</span> A/R</p>
      )}
      {!off && (cheapest || fastest) ? (
        <div className="mt-2 flex flex-wrap gap-1">
          {cheapest ? <span data-testid={`${testid}-cheapest`} className="px-1.5 py-0.5 rounded bg-emerald-100 text-emerald-800 text-[10px] font-medium">Plus économique</span> : null}
          {fastest ? <span data-testid={`${testid}-fastest`} className="px-1.5 py-0.5 rounded bg-amber-100 text-amber-900 text-[10px] font-medium">Plus rapide</span> : null}
        </div>
      ) : null}
      {detailed && !off && data?.details ? <p className="mt-2 text-xs text-gray-500 leading-relaxed">{data.details}</p> : null}
    </div>
  );
};

export const TransportCompare = ({ transport = {}, detailed = false, testid = "transport-compare" }) => (
  <div data-testid={testid} className="grid grid-cols-2 gap-2">
    <Option icon={Train} label="Train" data={transport.train} recommended={transport.recommended === "train"} detailed={detailed} testid={`${testid}-train`}
      cheapest={transport.cheapest === "train"} fastest={transport.fastest === "train"} />
    <Option icon={Car} label="Voiture" data={transport.car} recommended={transport.recommended === "voiture"} detailed={detailed} testid={`${testid}-car`}
      cheapest={transport.cheapest === "car"} fastest={transport.fastest === "car"} />
  </div>
);
